import { render, staticRenderFns } from "./SendedNotificationDetail.vue?vue&type=template&id=4e5d13c8"
import script from "./SendedNotificationDetail.vue?vue&type=script&lang=js"
export * from "./SendedNotificationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports